import {
    CREATE_INVENTORY_FAIL,
    CREATE_INVENTORY_SUCCESS,
    DELETE_INVENTORY_FAIL,
    DELETE_INVENTORY_SUCCESS,
    GET_INVENTORY_DETAILS_FAIL,
    GET_INVENTORY_DETAILS_SUCCESS,
    GET_INVENTORY_FILTERS_FAIL,
    GET_INVENTORY_FILTERS_SUCCESS,
    GET_INVENTORY_STOCK_STATUSES_FAIL,
    GET_INVENTORY_STOCK_STATUSES_SUCCESS,
    GET_INVENTORY_LISTING_FAIL,
    GET_INVENTORY_LISTING_SUCCESS,
    RESET_INVENTORY_ACTION_STATE,
    RESET_INVENTORY_STATE,
    UPDATE_INVENTORY_FAIL,
    UPDATE_INVENTORY_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    inventoryListing: [],
    coeBiddingList: [],
    inventoryDetails: [],
    inventoryFilters: [],
    inventoryStockStatuses: [],
    inventoryInterestRate: [],
    inventoryAdd: [],
    inventoryEdit: [],
    inventoryDelete: [],
    error: [],
}

const Inventory = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_INVENTORY_LISTING_SUCCESS:
            return {
                ...state,
                inventoryListing: action.payload
            }
        case GET_INVENTORY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_INVENTORY_DETAILS_SUCCESS:
            return {
                ...state,
                inventoryDetails: action.payload
            }
        case GET_INVENTORY_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
                inventoryDetails: action.payload,
            }
        case GET_INVENTORY_FILTERS_SUCCESS:
            return { ...state, inventoryFilters: action.payload }
        case GET_INVENTORY_FILTERS_FAIL:
            return { ...state, error: action.payload }
        case GET_INVENTORY_STOCK_STATUSES_SUCCESS:
            return { ...state, inventoryStockStatuses: action.payload }
        case GET_INVENTORY_STOCK_STATUSES_FAIL:
            return { ...state, error: action.payload }
        case CREATE_INVENTORY_SUCCESS:
            return {
                ...state,
                inventoryAdd: action.payload
            }
        case CREATE_INVENTORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_INVENTORY_SUCCESS:
            return {
                ...state,
                inventoryEdit: action.payload
            }
        case UPDATE_INVENTORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_INVENTORY_SUCCESS:
            return {
                ...state,
                inventoryDelete: action.payload
            }
        case DELETE_INVENTORY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_INVENTORY_ACTION_STATE:
            return {
                ...state,
                inventoryAdd: [],
                inventoryEdit: [],
                inventoryDelete: [],
                inventoryInterestRate: [],
                error: [],
            }

        case RESET_INVENTORY_STATE:
            return {
                ...state,
                inventoryListing: [],
                inventoryDetails: [],
                inventoryFilters: [],
                inventoryStockStatuses: [],
                inventoryAdd: [],
                inventoryEdit: [],
                inventoryDelete: [],
                inventoryInterestRate: [],
                singpassRes: [],
                error: [],
            }
        default:
            return state
    }
}

export default Inventory
